import React from 'react';
import { motion } from 'framer-motion';
import { toast } from 'sonner';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  fullWidth?: boolean;
}
export function Button({
  children,
  className = '',
  fullWidth = false,
  ...props
}: ButtonProps) {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (props.onClick) {
      props.onClick(e);
      return;
    }
    const target = document.getElementById('offer-cta') || document.getElementById('offer');
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={handleClick} className={`
        bg-teal text-white font-bold text-lg md:text-xl py-4 px-8 rounded-2xl
        shadow-[0_8px_20px_rgba(43,166,164,0.3)] hover:shadow-[0_12px_25px_rgba(43,166,164,0.4)]
        transition-shadow duration-300 flex items-center justify-center text-center
        ${fullWidth ? 'w-full' : 'w-full md:w-auto'}
        ${className}
      `} {...props} data-id="element-193">
      {children}
    </motion.button>;
}